import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { useRef } from "react";
import {
  CreatePriorAuthorizationAuthorizationStatusEnum,
  PriorAuthorizationControllerApi,
} from "../../../../services";
import {
  DGT_Pagination,
  getConfigObject,
  getPageIndexWhileSearch,
  getPageSize,
  useBaseContent,
} from "../../../../utils/utils";

interface Props {
  pagination: DGT_Pagination;
  sortBy?: string;
  sortDirection?: string;
  authorizationStatus?: CreatePriorAuthorizationAuthorizationStatusEnum;
  archive?: boolean;
  patientId: string;
  xTENANTID?: string;
}

export type AuthorizationData = {
  details: Array<any>;
};

/**
 *
 * @author Rajkumar Rathod
 */
export const useAuthorizationList = ({
  pagination,
  sortBy,
  sortDirection,
  authorizationStatus,
  archive,
  patientId,
  xTENANTID,
}: Props): useBaseContent<AuthorizationData> => {
  const prevPage = useRef<number>(pagination.page);
  const pageIndex = getPageIndexWhileSearch({
    pagination,
    searchKey: "",
    prevPage,
  });

  const pageSize = getPageSize("", pagination);
  return useQuery({
    queryKey: [
      "authorization-list",
      pageIndex,
      pageSize,
      sortBy,
      sortDirection,
      authorizationStatus,
      archive,
      patientId,
      xTENANTID,
    ],
    refetchOnWindowFocus: false,


    placeholderData: keepPreviousData,
    queryFn: async () =>
      await new PriorAuthorizationControllerApi(getConfigObject())
        .getAllPriorAuthorization(
          pageIndex,
          pageSize,
          sortBy,
          sortDirection,
          authorizationStatus,
          archive,
          patientId,
          xTENANTID
        )
        .then((res) => res?.data),
  });
};
